/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components */
import AttendanceCalendarDays from 'linced-app/components/attendance-calendar-days';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import SchoolStatus from '@linc-technologies/linced-common/enums/school-status';
import moment from 'moment';
import {
  getStructuresFromDates,
  isPeriodPresentOnDay,
} from 'linced-app/utils/timetables';

export default class AttendanceCalendar extends Component {
  // Component class rather than a string: a string here reaches
  // `ensureSafeComponent` and trips `ensure-safe-component.string`.
  daysComponent = AttendanceCalendarDays;
  @service
  session;

  @service
  dates;

  @service
  terms;

  SchoolStatus = SchoolStatus;

  @alias('session.school.jurisdiction')
  jurisdiction;

  @computed('jurisdiction')
  get trackMovements() {
    return this.jurisdiction !== Jurisdiction.NZ_MOE;
  }

  @computed('dates.currentDate')
  get minDate() {
    let lastYear = moment().subtract(1, 'year').year();
    return moment(`${lastYear}-01-01`);
  }

  @computed('dates.currentDate')
  get maxDate() {
    let thisYear = moment().year();
    return moment(`${thisYear}-12-31`);
  }

  @tracked term = null;
  @tracked
  year = moment().year();

  @computed('term', 'dates.structures.[]')
  get timetableStructures() {
    if (isEmpty(this.term)) {
      return [];
    }
    // Find any timetable structures which start during this term.
    return getStructuresFromDates(
      this.get('term.start'),
      this.get('term.end'),
      this.dates.structures,
    );
  }

  @computed('timetableStructures.[]')
  get showSaturday() {
    return isPeriodPresentOnDay(this.timetableStructures, 6);
  }

  @computed('timetableStructures.[]')
  get showSunday() {
    return isPeriodPresentOnDay(this.timetableStructures, 7);
  }

  @action
  changeTerm(term) {
    let newYear = term.get('year');
    if (newYear !== this.get('term.year')) {
      // When navigating between years, load the appropriate dates.
      // We may already have them, but a reload can't hurt.
      this.year = newYear;
      this.dates.loadYear(newYear, true);
    }
    this.term = term;
  }

  @action
  messageClass(isOpen) {
    let classNames = ['attendance-message'];
    if (isOpen) {
      classNames.push('open');
    }
    if (this.trackMovements) {
      classNames.push('has-movement-log');
    }
    return classNames.join(' ');
  }
}
